export const DEFAULT_COUNTRY = {
  countryName: "us",
  dialCode: 1,
};
